import { render, staticRenderFns } from "./NotificationBlock.vue?vue&type=template&id=c21cf6dc&scoped=true&"
import script from "./NotificationBlock.vue?vue&type=script&lang=js&"
export * from "./NotificationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21cf6dc",
  null
  
)

export default component.exports